<template>
  <div class="checkList">
    <div class="pageCent">
      <keep-alive>
        <goods-list :initData="initData" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import goodsList from '../../components/goodsList'
import { topUpShelfProductList } from '../../api/home'

export default {
  name: 'viewMorenew',
  data: () => ({
    queryItems: {
      pageNum: 1,
      pageSize: 30
    },
    initData: [],
    total: 0
  }),
  components: {
    goodsList
  },
  created () {
    //  新品上架
    this.getTopUpShelfProductList()
  },
  methods: {
    // 新品上架
    // 分页没有传数据
    getTopUpShelfProductList () {
      topUpShelfProductList(this.queryItems).then(res => {
        if (res.data.success) {
          this.initData = res.data.data.pageInfo.list
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkList{
    width: 100%;
    background-color: #f2f2f2;
    .pageCent{
      width: 1200px;
      margin: 0 auto;
    }
  }
</style>
